import gql from 'graphql-tag'

import { main, immutable } from './fragments'

export default gql`
query getLoyaltyCard($id: ID!) {
	cashAssist {
		getLoyaltyCard(id: $id) {
			id: idTemp
			mod_ver
			...immutable
			...loyaltyCardMain
		}
	}
}
${main}
${immutable}`
